import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import { CreateArmyListUnitPresenter } from '@Selectors/builder/myArmyList/make/unit/new/CreateArmyListUnitPresenter';
import { container } from '@Container';
import { TYPES } from '@Types';
import { ArmyListUnitAction, UserFavoriteUnitsAction } from '@Redux/actions';
import Loader from '@Components/utils/loader/loader.component';
import Repeater from '@Utils/Repeater';
import {
  AvailableUnitCategoryView,
  AvailableUnitView,
  FavoriteUnitView
} from '@Selectors/builder/myArmyList/make/unit/new/view/AvailableUnitCategoryView';
import Titre from '@Components/utils/titre/titre.component';
import { SectionCreateUnit, UnitRow } from './create-army-list-unit.component.styled';
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

interface CreatePaintListUnitProps {
  organisationId?: number | string;
}

const CreateArmyListUnit: React.FC<Props> = (
  {
    showTitle,
    datas,
    createUnit,
    createUnitFromFavorite,
    deleteFavorite
  }
) => {

  if (datas.isLoading) {
    return (<Loader />);
  }

  return (
    <>
      <Repeater data={datas.units} indexPrefix="category">
        {
          (item: AvailableUnitCategoryView) => (
            <SectionCreateUnit>
              {showTitle && (<Titre texte={item.label} className='text-center' niveau={3} />)}
              <div className='section-create-unit'>
                <Repeater data={item.options} indexPrefix="unit">
                  {
                    (unit: AvailableUnitView) => (
                      <div className='create-unit'>
                        <UnitRow>
                          <div className="py-3 px-2 p-md-1" onClick={() => createUnit(unit)}>
                            <i className="fa-solid fa-plus"></i>
                            <span className="name ms-1">{unit.name}</span>
                            <span className="cost">{unit.points}
                              <FormattedMessage {...defaultMessages.ninthAgeFigurinePts} /></span>
                          </div>
                          <a className="py-3 px-2 p-md-1" target="_blank" href={`/ninth_age/units/${unit.id}`}><i
                            className="fa-solid fa-external-link ms-1"></i></a>
                        </UnitRow>
                        <Repeater data={unit.favoriteUnits} indexPrefix="favorite-unit">
                          {
                            (favoriteUnit: FavoriteUnitView) => (
                              <UnitRow className="ms-3">
                                <div className="py-3 px-2 p-md-1" onClick={() => createUnitFromFavorite(favoriteUnit)}>
                                  <i className="fa-solid fa-plus"></i>
                                  <span className="name ms-1">{favoriteUnit.name}</span>
                                </div>
                                <a className="py-3 px-2 p-md-1" href="#" onClick={() => deleteFavorite(favoriteUnit)}>
                                  <i className="fa-solid fa-trash ms-1"></i>
                                </a>
                              </UnitRow>
                            )
                          }
                        </Repeater>
                      </div>
                    )
                  }
                </Repeater>
              </div>
            </SectionCreateUnit>
          )
        }
      </Repeater>
    </>
  );
};

const mapStateToProps = (state: AppState, owsProps: CreatePaintListUnitProps) => ({
  datas: CreateArmyListUnitPresenter(state, owsProps),
  showTitle: isNaN(Number(owsProps.organisationId))
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const armyListUnitAction = container.get<ArmyListUnitAction>(TYPES.Actions.ArmyListUnitAction);
  const userFavoriteUnitAction = container.get<UserFavoriteUnitsAction>(TYPES.Actions.NinthAge.FavoriteUnit.UserFavoriteUnitsAction);
  return {
    createUnit: (unit: AvailableUnitView) => {
      dispatch(armyListUnitAction.armyListUnitCreation(unit.id))
    },
    createUnitFromFavorite: (unit: FavoriteUnitView) => {
      dispatch(armyListUnitAction.createUnitFromFavorite({ unit: unit }))
    },
    deleteFavorite: (unit: FavoriteUnitView) => {
      dispatch(userFavoriteUnitAction.delete({ unitId: unit.id }))
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateArmyListUnit);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  CreatePaintListUnitProps
